var ShowcaseJobListing = {};

( function ( $ ) {

	var container = $( '.showcase-job-listing-container' );
	var showTheRestButton = $( '.showcase-job-listing-show-the-rest' );
	var total = $( '#total' );
	var sortField = $( '#showcase-job-listing-sort' );
	var loader = container.siblings( 'div.loader' );
	var header = $( '.js-header' );
	var data;
	var sortMode;	

	var loadData = function () {
		data = JSON.parse( $( '#dataShowcaseJobListing' ).text() );

		var ajaxData = {
			action: 'get_initial_showcase_jobs',
			count: data.count
		};

		if ( typeof data.pnty_job_tag !== 'undefined' ) {
			ajaxData.pnty_job_tag = data.pnty_job_tag;
		}

		if ( typeof sortMode !== 'undefined' ) {
			ajaxData.sort_mode = sortMode;
		}

		$.ajax( {
			url: ajaxURL,
			method: 'GET',
			dataType: 'json',
			data: ajaxData,
			beforeSend: function () {
				showTheRestButton.parent().hide();
				sortField.parents( 'div.text-center' ).hide();
				container.html( '' );
				loader.show();
			},
			success: function ( result ) {
				container.append( result.html );
				total.html( result.job_count );

				// Load images
				MultiImage.init( container.find( '.js-multi-image' ) );

				if ( parseInt( data.count ) >= parseInt( result.company_count ) ) {
					showTheRestButton.parent().hide();
				} else {
					showTheRestButton.parent().show();
				}

				header.removeClass( 'hide' );
			},
			error: function ( result ) {
				console.error( result );
			},
			complete: function () {
				sortField.parents( 'div.text-center' ).show();
				loader.hide();
			}
		} );
	};

	var showTheRest = function () {
		var ajaxData = {
			action: 'get_rest_showcase_jobs',
			offset: data.count
		};

		if ( typeof data.pnty_job_tag !== 'undefined' ) {
			ajaxData.pnty_job_tag = data.pnty_job_tag;
		}

		if ( typeof sortMode !== 'undefined' ) {
			ajaxData.sort_mode = sortMode;
		}

		$.ajax( {
			url: ajaxURL,
			method: 'GET',
			dataType: 'json',
			data: ajaxData,
			beforeSend: function () {
				showTheRestButton.parent().hide();
				loader.show();
			},
			success: function ( result ) {
				container.append( result.html );

				// Load images
				MultiImage.init( container.find( '.js-multi-image' ) );

				showTheRestButton.parent().hide();
			},
			error: function ( result ) {
				console.error( result );
			},
			complete: function () {
				loader.hide();
			}
		} );
	};

	ShowcaseJobListing.init = function () {
		loadData();

		showTheRestButton.click( showTheRest );

		sortField.change( function () {
			sortMode = $( this ).val();
			loadData();
		} );
	};

	if ( container.length ) {
		$( ShowcaseJobListing.init );
	}
} )( jQuery );